// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promocode-history-page .promocode-history-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 32px;\n  margin: 20px 0 18px;\n  color: #242424;\n  font-size: 16px;\n  font-weight: 600;\n}\n.promocode-history-page .promocode-history-empty {\n  padding: 18px 0;\n  color: #8b8b8b;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
